import {
  CommonButton,
  RadioGroup,
  RippleEffect,
  StepSixTable,
} from "components/UiElement";
import { Form, Formik } from "formik";
import { Link } from "react-router-dom";
import { validation } from "./validation";

function StepSixForm({
  permissionArray,
  onSubmit,
  t,
  userData,
  setAddModal,
  setUserFor,
  deleteMember,
  setUserValueModal,
  stepData,
}) {
  let initialValues = {
    permissionStatus: "" || stepData.permissionStatus,
  };
  return (
    <Formik
      initialValues={{ ...initialValues }}
      onSubmit={onSubmit}
      validationSchema={validation()}
    >
      {(props) => {
        return (
          <div className="commonCard bg-white">
            <Form>
              <div className="commonCard_head">
                <h2 className="mb-0">
                  <span>06</span>
                  {t("text.createMemories.addPermission")}
                </h2>
                {/* <p className="mb-0">Click who can view the memorial</p> */}
              </div>
              <div className="subPermission">
                <div className="commonCard_head mb-0">
                  <h2 className="mb-xxl-1 mb-0 subTitle">
                    {t("text.createMemories.memorialViewPermission")}
                  </h2>
                  <p>Click who can view the memorial</p>
                </div>
                <div className="permissionsRadio">
                  <div className="form-group">
                    <RadioGroup
                      setFieldValues={props.handleChange}
                      name="permissionStatus"
                      Item={permissionArray}
                    />
                  </div>
                  <div className="text-end">
                    <RippleEffect extraClassName="w-20 ps-3">
                      <CommonButton
                        variant="danger"
                        className="btn-sm w-100"
                        type="submit"
                      >
                        {t("text.common.submit")}
                      </CommonButton>
                    </RippleEffect>
                  </div>
                </div>
                {props?.values?.permissionStatus === "private" && (
                  <div className="mt-3 mt-lg-4">
                    <RippleEffect extraClassName="d-flex justify-content-end">
                      <Link
                        onClick={(e) => {
                          e.preventDefault();
                          setUserFor("view");
                          setAddModal(true);
                        }}
                        className="btn btn-sm btn-outline-danger mt-sm-0 mt-2"
                      >
                        +{t("text.createMemories.addMember")}
                      </Link>
                    </RippleEffect>
                    <div className="stepsContent_table">
                      <StepSixTable
                        userData={userData}
                        t={t}
                        deleteMember={deleteMember}
                        setUserValueModal={setUserValueModal}
                      />
                    </div>
                  </div>
                )}
              </div>
            </Form>
          </div>
        );
      }}
    </Formik>
  );
}

export default StepSixForm;
